export const from = 7;
export const to = 8;

export function up(schema) {
  const { items, ...rest } = schema;
  const copiedItems = JSON.parse(JSON.stringify(items));

  // Get storyboard entities
  const entitiesList = copiedItems.ids.map((id) => copiedItems.entities[id]);

  // Update all text items only with default variant
  const newEntitiesList = entitiesList.map((item) =>
    item.mediaType === 'text'
      ? { textVariant: item.fontSize > 28 ? 'header' : 'body', ...item }
      : item
  );

  // Return entities to the storyboard
  newEntitiesList.forEach((entity) => {
    copiedItems.entities[entity.id] = entity;
  });

  return {
    items: copiedItems,
    ...rest,
    version: to,
  };
}

export function down(schema) {
  const { items, ...rest } = schema;
  const copiedItems = JSON.parse(JSON.stringify(items));

  // Get storyboard entities
  const entitiesList = copiedItems.ids.map((id) => copiedItems.entities[id]);

  // Update all text items only
  const newEntitiesList = entitiesList.map((item) => {
    const { textVariant, ...oldItem } = item;
    return oldItem;
  });

  // Return entities to the storyboard
  newEntitiesList.forEach((entity) => {
    copiedItems.entities[entity.id] = entity;
  });

  return {
    items: copiedItems,
    ...rest,
    version: from,
  };
}

export default {
  from,
  to,
  up,
  down,
};
